// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CourseSchedulingDetailsScreenLayout} from 'app_components/screens/admin/courseSchedulingDetails'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import CourseSchedulingDetailsService from 'app_services/admin/courseScheduling/courseSchedulingDetailsService'
import CourseSchedulingService from 'app_services/admin/courseScheduling/courseSchedulingService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { INewCourseSchedulingDetails, ICourseSchedulingDetailListItem, ICourseSchedulingDetailsHttpResponse } from 'app_types/admin/courseScheduling/courseSchedulingDetailsTypes'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @ADD Component types
interface ICourseSchedulingDetailsScreenProps {
  match?: any
}
interface ICourseSchedulingDetailsScreenState {
  status: null | 'loading' | 'error'
  courseScheduling: ICourseSchedulingListItem | null
  itemList: ICourseSchedulingDetailListItem[]
  add: boolean
  edit: boolean
  view: boolean
  editData: null | ICourseSchedulingDetailListItem
  selectedRow: null | string
  pagination: IPagination,
  scheduling: string[]
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CourseSchedulingDetailsScreen extends Component<ICourseSchedulingDetailsScreenProps, ICourseSchedulingDetailsScreenState> {

  public moduleName: string = 'module:course_scheduling'
  private permission: PermissionService
  private screenNotifications: ScreenNotificationsUtil
  private itemService: CourseSchedulingDetailsService
  private courseSchedulingService: CourseSchedulingService
  private i18nUtil: I18nUtil
  private course_scheduling: any = null

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICourseSchedulingDetailsScreenProps) {
    super(props)
    this.state = {
      status: 'loading',
      courseScheduling: null,
      itemList: [],
      add: false,
      edit: false,
      view: false,
      editData: null,
      selectedRow: null,
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
      scheduling: []
    }

    this.permission = new PermissionService(this.moduleName)
    this.screenNotifications = new ScreenNotificationsUtil()
    this.itemService = new CourseSchedulingDetailsService()
    this.i18nUtil = new I18nUtil()
    this.courseSchedulingService = new CourseSchedulingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.props?.match?.params?.course_scheduling) {
      this.course_scheduling = this.props?.match?.params?.course_scheduling
      this.fetchCourseScheduling()
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  fetchCourseScheduling = async () => {
    const courseSchedulingResponse = await this.courseSchedulingService.getOne(this.course_scheduling)
    if (courseSchedulingResponse) {
      this.setState({
        courseScheduling: courseSchedulingResponse
      }, async () => {
        await this.getList()
      })
    } else {
      this.setState({
        status: null
      })
    }
  }


  onRowClick = async (row: any) => {
    if (this.state.selectedRow === row._id) {
      this.setState({ selectedRow: null })
    } else {
      // this.setState({ status: 'loading' })
      const item: any = this.state.itemList.find((item) => item._id === row._id)

      if (!item?.details) {
        await this.getItem(row._id)
      }

      this.setState({
        selectedRow: row._id,
        // status: null,
      })
    }
  }

  showAddForm = async (add: boolean) => {
    this.setState({ add })
  }

  showEditForm = async (edit: boolean, register?: any) => {
    if (edit && register) {
      await this.getItem(register._id)
      this.setState({ edit: true, editData: register })
    } else {
      this.setState({ edit: false })
    }
  }

  onViewerRow = async (view: boolean, register?: any) => {
    if (view && register) {
      await this.getItem(register._id)
      this.setState({ view: true, editData: register })
    } else {
      this.setState({ view: false })
    }
  }

  onPageChange = async (page: number) => {
    this.getList({ page })
  }

  onSearch = async (event: any) => {
    this.getList({ page: 1, search: event.search })
    return false
  }

  getItem = async (id: string) => {
    // this.setState({ status: 'loading' })

    const itemIndex = this.state.itemList.findIndex((item) => item._id === id)
    const itemList: Array<any> = [...this.state.itemList]

    const item: any = await this.itemService.getOne(id)
    if (item) {
      itemList[itemIndex].details = item
    } else {
      // this.setState({ status: 'error' })
    }
  }

  getList = async (params?: any) => {
    this.setState({ status: 'loading' })

    const httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      isActive: false,
      sort: JSON.stringify({
        field: 'startDate',
        direction: '1'
      })
    }

    if (params?.search) {
      httpParams.search = params?.search
    }

    if (this.course_scheduling) {
      httpParams.course_scheduling = this.course_scheduling
    }

    let itemList: ICourseSchedulingDetailsHttpResponse | null = await this.itemService.list(httpParams)

    if (itemList?.status_code === 'success') {
      const _scheduling = itemList?.schedulings.reduce((accum: string[], element) => {
        accum.push(element.course.moodle_id.toString())
        return accum
      }, [])
      this.setState({
        itemList: itemList?.schedulings,
        pagination: {
          total: itemList?.total_register,
          perPage: itemList?.nPerPage,
          page: itemList?.pageNumber,
        },
        status: null,
        scheduling: _scheduling
      })

    } else {
      this.setState({ status: 'error' })
    }
  }

  addItem = async (response: any) => {
    if (response) {
      this.setState({ add: false })
      this.fetchCourseScheduling()
      this.getList()
    }
  }

  updateItem = async (response: INewCourseSchedulingDetails) => {
    if (response) {
      this.setState({ edit: false })
      this.fetchCourseScheduling()
      this.getList()
    }
  }

  removeItem = async (id: string) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('screens.course_scheduling.details.delete.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('screens.course_scheduling.details.delete.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,
      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          // this.setState({ status: 'loading' })

          const remove = await this.itemService.remove(id)

          if (remove) {
            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate('components.screen_notifications.delete')}`,
              },
              {
                position: 'bottom-right',
              },
            )

            this.getList()
          }

          // this.setState({ status: null })
        }
      })
    }
  }

  render() {
    return(
      <CourseSchedulingDetailsScreenLayout
        add={this.permission.check('permission:course_scheduling_create', this.state.add)}
        edit={this.permission.check('permission:course_scheduling_update', this.state.edit)}
        view={this.permission.check('permission:course_scheduling_viewer', this.state.view)}
        editData={this.state.editData}
        onRowClick={this.onRowClick}
        onViewerRow={this.permission.check('permission:course_scheduling_viewer', this.onViewerRow)}
        selectedRow={this.state.selectedRow}
        showAddForm={this.permission.check('permission:course_scheduling_create', this.showAddForm)}
        showEditForm={this.permission.check('permission:course_scheduling_update', this.showEditForm)}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        itemList={this.permission.check('permission:course_scheduling_list', this.state.itemList)}
        addItem={this.permission.check('permission:course_scheduling_create', this.addItem)}
        updateItem={this.permission.check('permission:course_scheduling_update', this.updateItem)}
        removeItem={this.permission.check('permission:course_scheduling_delete', this.removeItem)}
        onSearch={this.permission.check('permission:course_scheduling_list', this.onSearch)}
        status={this.state.status}
        courseScheduling={this.state.courseScheduling}
        scheduling={this.state.scheduling}
      />
    )
  }
}

export default connect(mapStatesToProps)(CourseSchedulingDetailsScreen)
